module.exports = __webpack_public_path__ + "img/stock7.95346693.png";